/**
 * Author: SCS (Santosh Chandra Shekhar)
 * ***scs***
 */

import React, { useContext } from "react";
import "./Intro.css";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
// import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
// import Github from "../../img/github.png";
// import LinkedIn from "../../img/linkedin.png";
// import Instagram from "../../img/instagram.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import ReactPlayer from "react-player";

const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span className="blink"  style={{ color: darkMode ? "white" : "" }}>Hi!! I am</span>
          <span className="shine_name">Santosh Chandra Shekhar</span>

          <span>
           I'm a self-taught web developer who enjoys creating websites and web applications that are both visually appealing and functional. I specialize in HTML, CSS, JavaScript, ReactJS, AI automation, and prompt engineering. I'm passionate about learning new technologies and finding creative solutions to complex problems.
          </span>
        </div>
        <Link className="mob_pos" to="contact" smooth={true} spy={true}>
          <button className="button i-button mobile_view"> Hire me </button>
        </Link>
        {/* Know more */}
        
        {/* social icons */}
        {/* <div className="i-icons">
          <img src={Github} alt="" />
          <img src={LinkedIn} alt="" />
          <img src={Instagram} alt="" />
        </div> */}
      </div>
      {/* right image side */}
      <div className="i-right">
        <ReactPlayer className="mob" controls url="https://youtu.be/kbJJOZussr0" />
        
        
        {/* animation */}
        < motion.img
          initial={{ left: "-34%" }}
          whileInView={{ left: "-28%" }}
          transition={transition}
          src={glassesimoji}
          alt="motion-img"
        />

        {/* <motion.div
          initial={{ top: "-4%", left: "72%" }}
          whileInView={{ left: "70%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Web" text2="Developer" />
        </motion.div> */}

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Best Design" text2="Developer" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
